const formatFacultad = (value) => {
  const facultades = {
    facultad_de_ciencias_exactas_y_naturales: "Facultad de Ciencias Exactas y Naturales",
    facultad_de_ingenierias_y_arquitectura: "Facultad de Ingenierías y Arquitectura",
    facultad_de_ciencias_economicas_y_empresariales: "Facultad de Ciencias Económicas y Empresariales",
  facultad_de_ciencias_juridicias_y_politicas:"Facultad de Ciencias Jurídicas y Políticas",
  facultad_de_ciencias_sociales_educacion_y_humanidades:"Facultad de Ciencias Sociales, Educación y Humanidades",
facultad_de_ciencias_del_comportamiento: "Facultad de Ciencias del Comportamiento",  
facultad_de_ciencias_de_la_salud:"Facultad de Ciencias de la Salud",
};

  return facultades[value] || value;
};

const Facultad = ({ value }) => {
  if (!value || (Array.isArray(value) && value.length === 0)) {
    return null;
  }

  const facultades = (Array.isArray(value) ? value : [value])
    .filter(Boolean)
    .map(formatFacultad);

  return <>{facultades.join(" / ")}</>;
};

export default Facultad;